import { useEffect, useState } from 'react';
import { soltarConfete } from './confete';
import './confete.css';

/**
 * COMEMORAÇÕES do balconista (dono, 25/09 — o 1.0 tinha e o 2.0 faz melhor):
 *   - GRANDE: tela cheia com confete (meta da semana batida, meta do mês batida);
 *   - AVISO: faixa curta no topo que some sozinha (50/75/90% da meta, subiu no ranking);
 *   - SOM de moeda (card que paga, venda registrada), respeitando a preferência "Som ao registrar
 *     venda" da Minha conta (fica neste aparelho).
 * Qualquer tela chama `comemorar(...)`; quem desenha é <Comemoracoes/>, montado no shell.
 */

export type Comemoracao = {
  readonly tipo: 'grande' | 'aviso';
  readonly titulo: string;
  readonly texto?: string;
};

const EVENTO = 'inovapay:comemorar';

export function comemorar(c: Comemoracao): void {
  try {
    window.dispatchEvent(new CustomEvent<Comemoracao>(EVENTO, { detail: c }));
  } catch {
    // comemoração nunca derruba a tela
  }
}

export function somLigado(): boolean {
  try {
    return window.localStorage.getItem('inovapay2.pref.som-venda') !== '0';
  } catch {
    return true;
  }
}

let audio: AudioContext | null = null;
/** "Plim" de moeda: duas notas curtas, sintetizadas (sem arquivo de som). */
export function somDeMoeda(): void {
  if (!somLigado()) return;
  try {
    const Ctx =
      window.AudioContext ??
      (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
    if (!Ctx) return;
    audio ??= new Ctx();
    const ctx = audio;
    const agora = ctx.currentTime;
    for (const [i, freq] of [988, 1319].entries()) {
      const osc = ctx.createOscillator();
      const vol = ctx.createGain();
      osc.type = 'square';
      osc.frequency.value = freq;
      const t = agora + i * 0.08;
      vol.gain.setValueAtTime(0.0001, t);
      vol.gain.exponentialRampToValueAtTime(0.08, t + 0.01);
      vol.gain.exponentialRampToValueAtTime(0.0001, t + (i === 0 ? 0.09 : 0.35));
      osc.connect(vol).connect(ctx.destination);
      osc.start(t);
      osc.stop(t + 0.4);
    }
  } catch {
    // aparelho sem áudio: segue em silêncio
  }
}

export function Comemoracoes() {
  const [grande, setGrande] = useState<Comemoracao | null>(null);
  const [aviso, setAviso] = useState<Comemoracao | null>(null);

  useEffect(() => {
    const ouvir = (e: Event) => {
      const c = (e as CustomEvent<Comemoracao>).detail;
      if (c.tipo === 'grande') {
        setGrande(c);
        somDeMoeda();
        soltarConfete(90);
        window.setTimeout(() => soltarConfete(70), 600);
        window.setTimeout(() => soltarConfete(70), 1200);
      } else setAviso(c);
    };
    window.addEventListener(EVENTO, ouvir);
    return () => window.removeEventListener(EVENTO, ouvir);
  }, []);

  useEffect(() => {
    if (!aviso) return;
    const t = window.setTimeout(() => setAviso(null), 4500);
    return () => window.clearTimeout(t);
  }, [aviso]);

  return (
    <>
      {aviso && (
        <div className="cm-aviso" role="status" onClick={() => setAviso(null)}>
          <b>{aviso.titulo}</b>
          {aviso.texto && <span>{aviso.texto}</span>}
        </div>
      )}
      {grande && (
        <div className="cm-fundo" role="dialog" aria-modal="true" aria-label={grande.titulo}>
          <div className="cm-cartao">
            <div className="cm-trofeu" aria-hidden="true">
              🏆
            </div>
            <div className="cm-titulo">{grande.titulo}</div>
            {grande.texto && <p className="cm-texto">{grande.texto}</p>}
            <button type="button" className="cm-botao" onClick={() => setGrande(null)}>
              Bora vender mais!
            </button>
          </div>
        </div>
      )}
    </>
  );
}
